module.exports = __webpack_public_path__ + "img/supportive.4efd3546.jpg";